import { ApolloClient, ApolloLink, InMemoryCache, makeVar } from '@apollo/client'
import { BatchHttpLink } from '@apollo/client/link/batch-http'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'
import { relayStylePagination } from '@apollo/client/utilities'
import { createUploadLink } from 'apollo-upload-client'
import Cookies from 'js-cookie'
import { TypedTypePolicies } from './generated/apollo-helpers'
import { CachePersistor, LocalStorageWrapper } from 'apollo3-cache-persist'
import { LOCAL_STORAGE_KEYS } from './constants'

export const isWholesaleModeVar = makeVar(Boolean(localStorage.getItem(LOCAL_STORAGE_KEYS.WHOLESALE_MODE)))

export function findValueInEnum(needle, haystack) {
  // const match = Object.entries(haystack).find(([_, value]) => value === needle);
  //
  // if (!match) {
  //   throw new Error(`Value ${needle} not found in enum`);
  // }
  return needle
}

// const setCookieCsrf = async () => {
//     const response = await fetch('/get-csrf/');
//     const data = await response.json();
//     Cookies.set('csrftoken', data.csrf);
// };

// const getCookieCsrf = async () => {
//     const csrf = Cookies.get('csrftoken');
//     console.log('get csrf', csrf);
//     if (csrf) {
//         return csrf;
//     }
//     await setCookieCsrf();
//     return Cookies.get('csrftoken');
// };

const typePolicies: TypedTypePolicies = {
  Query: {
    fields: {
      specifics: relayStylePagination(['filters', 'ordering']),
      balanceTransactions: relayStylePagination([]),
      socialPosts: relayStylePagination(['filters', 'ordering']),
      productVariants: relayStylePagination(['filters']),
      cartLines: relayStylePagination(['cartType', 'filters', 'first']),
      blogArticleList: relayStylePagination(['filters', 'first']),
    },
  },
  FoundSpecificsType: {
    fields: {
      specifics: relayStylePagination(['filters']),
    },
  },
  CartType: {
    fields: {
      allLines: {
        merge: (_, incoming) => {
          return [...(incoming || [])]
        },
      },
      lines: relayStylePagination(['cartType']),
    },
  },
  UserType: {
    fields: {
      patternTransactions: relayStylePagination(['patternType']),
    },
  },
}

const SCHEMA_VERSION = process.env.SCHEMA_VERSION
const createClient = async () => {
  const cache = new InMemoryCache({
    typePolicies,
  })
  // if (process.env.NODE_ENV !== 'development') {

  const persistor = new CachePersistor({
    cache,
    storage: new LocalStorageWrapper(window.localStorage),
    maxSize: 1048576 * 4, // 4MB
  })
  const currentVersion = localStorage.getItem('APOLLO_SCHEMA_VERSION')
  try {
    if (currentVersion === SCHEMA_VERSION) {
      await persistor.restore()
    } else {
      await persistor.purge()
    }
  } catch (e) {
    await persistor.purge()
  }
  localStorage.setItem('APOLLO_SCHEMA_VERSION', SCHEMA_VERSION)
  // }

  const JWTError = {
    invalid: 'JSONWebTokenError',
    expired: 'JSONWebTokenExpired',
  }

  function isJwtError(error) {
    return !!findValueInEnum(error?.message, JWTError)
  }

  const invalidTokenLink = onError(({ graphQLErrors, networkError }) => {
    if (networkError || graphQLErrors?.some(isJwtError)) {
      Cookies.remove('csrftoken', { path: '' })
    }
    if (graphQLErrors)
      graphQLErrors.map(({ message, locations, path }) =>
        console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
      )

    if (networkError) console.log(`[Network error]: ${networkError}`)
  })

  const authLink = setContext((req, context) => {
    // const csrftoken = await getCookieCsrf();
    const csrftoken = Cookies.get('csrftoken') || ''
    if (csrftoken) {
      return {
        ...context,
        headers: {
          ...context.headers,
          'X-CSRFToken': csrftoken,
        },
      }
    } else {
      return context
    }
  })
  const linkOptions = {
    credentials: 'same-origin',
    uri: '/strawberry/graphql',
  }
  const uploadLink = createUploadLink(linkOptions)
  const batchLink = new BatchHttpLink({
    batchInterval: 10,
    batchMax: 3,
    ...linkOptions,
  })
  const link = ApolloLink.split(operation => !operation.getContext().notBatching, batchLink, uploadLink)

  return new ApolloClient({
    connectToDevTools: process.env.NODE_ENV === 'development',
    link: invalidTokenLink.concat(authLink.concat(link)),
    cache,
  })

  // client.onResetStore(async () => {
  //   await addDefaultsToCache(cache)
  // });
}
export default createClient
